import React, { useState, useEffect, Fragment} from 'react'
import { CardCommon } from 'src/components/uiElements'
import Chip from '@mui/material/Chip';
import {Button, ListContextProvider, useTranslate} from 'react-admin';
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service';
import { FormProvider, useForm } from 'react-hook-form';
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Tooltip from '@mui/material/Tooltip';
import LinkIcon from '@mui/icons-material/Link';
import IconButton from '@mui/material/IconButton';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  TableFooter,
  Skeleton,
  TextField,
  Autocomplete,
  Box,
  Button as ButtonMat,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography
} from '@mui/material'
import BusinessIcon from '@mui/icons-material/Business';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import { AccountStateFilters } from './logic/AccountStateFilters';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CancelIcon from '@mui/icons-material/Cancel';
import { accountStateServices } from 'src/services/reservation/accout-state/AccountState.service';
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand';
import { LoadingButton } from '@mui/lab';
import { currencyServices } from 'src/services/reservation/currency/currency.service';
import { productServices } from 'src/services/reservation/product/product.service';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { userServices } from 'src/services/reservation/user/user.service';
import { HeaderInfo } from './logic/HeaderInfo';
import { ExportButton } from './logic/ExportButton';
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission';
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput';
import { reservationServices } from 'src/services/sales/reservation/reservation.service';
import { TreeViewInput } from './logic/CustomTreeViewInput';
import { StatusTableCell } from '../../sales/reservation/helper/StatusTableCell';
import EditIcon from '@mui/icons-material/Edit';
import { Close } from '@mui/icons-material';
import { maxWidth, width } from '@mui/system';
import { isStatus } from '../../sales/reservation/helper/isStatus';

const expiredColor = 'rgb(241, 112, 103)'
const toExpireColor = 'rgb(68, 65, 65)'
const today = new Date()

const ReservationRow = ({reserve, setShowExtraTitles = ()=>{}, showExtraTitles}) =>{
  const translate = useTranslate()
  const [showItems, setShowItems] = useState(false)
  const [items, setItems] = useState([])
  const [loadingItems, setLoadingItems] = useState(false)

  const navigateToPayment = (reserve_id) =>{
    const url = new URL(window.location.href);
    const baseUrl = `${url.protocol}//${url.host}`;
    window.open(`${baseUrl}/#/reservation/${reserve_id}/show/`, '_blank');
  }

  let formatDate = new Intl.DateTimeFormat('es', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })

  const getItems = async () =>{
    setLoadingItems(true)
    await accountStateServices.getItems(reserve._id).then(res=>{
      setItems(res.results)
    }).finally(()=>{
      setLoadingItems(false)
    })
  }

  useEffect(()=>{
    if(showItems){
      getItems()
      setShowExtraTitles(showExtraTitles + 1)
    } 
  },[showItems])
  return(
    reserve?.items &&
    [
      <TableRow 
        key={reserve._id} 
        style={{cursor:reserve?.items.length > 0 ? 'pointer':'default'}} 
        onClick={()=>{
          if(reserve?.items.length > 0){
            if(showItems){
              setShowExtraTitles(showExtraTitles - 1)
            }
            setShowItems(!showItems); 
        }}}
        >
        <TableCell style={{color:'#6f7ce0'}}>
          <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
            {reserve.number}
            <LinkIcon style={{marginLeft:'5px'}} onClick={()=>navigateToPayment(reserve.id)}/>
          </div>
        </TableCell>
        <HasPermission permission='show_tma' resource={'account-state'}>
          <TableCell >
            {reserve.sale_id ?? ''}
          </TableCell>
        </HasPermission>
        <TableCell >
          {reserve.business_unit_name}
        </TableCell>
        <TableCell >
          <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
            {reserve.user}
          </div>
        </TableCell>
        <TableCell >
          {/* {(reserve?.items.length > 0 )? (reserve.items[0]?.pax_relation?.name + ' ' + reserve.items[0]?.pax_relation?.surname) : ''} */}
          {reserve.passenger}
        </TableCell>
        <TableCell >
          <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
            {reserve.currency}
          </div>
        </TableCell>
        <TableCell>
          <div style={{display:'flex', justifyContent:'flex-end'}}>
            {numberFormatterWithDecimalAndThousand(reserve.total_total)}
          </div>
        </TableCell>
        <TableCell>
          <div style={{display:'flex', justifyContent:'flex-end'}}>
            {numberFormatterWithDecimalAndThousand(reserve.total_paid)}
          </div>
        </TableCell>
        <TableCell>
          <div style={{display:'flex', justifyContent:'flex-end'}}>
            {numberFormatterWithDecimalAndThousand(reserve.total_pending_overdue)}
          </div>
        </TableCell>
        <TableCell>
          <div style={{display:'flex', justifyContent:'flex-end'}}>
            {numberFormatterWithDecimalAndThousand(reserve.total_pending_due)}
          </div>
        </TableCell>
        {/* <TableCell >
          {''}
        </TableCell> */}
        {showExtraTitles > 0 && Array.from({ length: 4 }, (_, i) =>i).map(i=>(
            <TableCell key={i}>
              {''}
            </TableCell>
          ))}
      </TableRow>,

      loadingItems ? Array.from({ length: 7 }).map((i)=>(
        <TableCell key={i}>
          <Skeleton variant='rectangular' height={40} width={'100%'}/>
        </TableCell>
      )):
      (showItems && items.length > 0) && items.map(item=>(
        <TableRow key={item._id}>
          {Array.from({ length: hasPermissionFunction('account-state', 'show_tma') ? 5 : 4 }, (_, i) =>i).map(i=>(
            <TableCell key={i}>
              {''}
            </TableCell>
          ))}
          <TableCell>
            <div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
              {item.currency_name}
            </div>
          </TableCell>
          <TableCell>
            <div style={{display:'flex', justifyContent:'flex-end'}}>
              {numberFormatterWithDecimalAndThousand(item.amount_total)}
            </div>
          </TableCell>
          <TableCell>
            <div style={{display:'flex', justifyContent:'flex-end'}}>
              {numberFormatterWithDecimalAndThousand(item.amount_paid)}
            </div>
          </TableCell>
          <TableCell>
            <div style={{display:'flex', justifyContent:'flex-end'}}>
              {
                item.status === 'DEFEATED' ? 
                  numberFormatterWithDecimalAndThousand(item.amount_pending):
                0
              }
            </div>
          </TableCell>
          <TableCell>
            <div style={{display:'flex', justifyContent:'flex-end'}}>
              {item.status === 'DUE' ?
                numberFormatterWithDecimalAndThousand(item.amount_pending):
                0
              }
            </div>
          </TableCell>
          <TableCell>
            {item.product_name}
          </TableCell>
          <TableCell>
              { item.due_date ? formatDate.format(new Date(item.due_date)) : ''}
          </TableCell>
          <TableCell style={{ padding: '0px 16px' }}>
            <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
            <Typography style={item.status ? { ...isStatus('status', item.status, true) } : undefined}>
              {translate(`ra.status.${item.status}`).includes('.') ? item.status : translate(`ra.status.${item.status}`)}
            </Typography>
            </div>
          </TableCell>
          <TableCell style={{ padding: '0px 16px' }}>
            <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
            <Typography style={item.billing_status ? { ...isStatus('status', item.billing_status, true) } : undefined}>
              {translate(`ra.status.${item.billing_status}`).includes('.') ? item.billing_status : translate(`ra.status.${item.billing_status}`)}
            </Typography>
            </div>
          </TableCell>
        </TableRow>
      ))
      
    ]
  )
}

export const AccountStateList = () => {
  const translate = useTranslate()
  const monthFormatter = new Intl.DateTimeFormat('es-ES', { month: 'long', weekday:'short'});
  const currentParts = monthFormatter.formatToParts(new Date());
  const [currentMonth, setCurrentMonth] = useState(currentParts.find(part=>part.type === 'month').value)
  const [dayToDisplay, setDayToDisplay] = useState(new Date())
  const [usersList, setUserList] = useState([])
  const [weekIndex, setWeekIndex] = useState(0)
  const [usersLoading, setLoadingUserList] = useState(false)
  const [sellerFilter, setSellerFilter] = useState(null)
  const [updateReserves, setUpdateReserves] = useState(false)
  const [totalsAmount, setTotalsAmount] = useState({})
  const [updateCreditReserves, setUpdateCreditReserves] = useState(false)
  const [reserves, setReserves] = useState([])
  const [loadingTotals, setLoadingTotals] = useState(false)
  const currencyOption = [
      {id:'USD', label:'USD'},
      {id:'ARS', label:'ARS'},
      {id:'MXN', label:'MXN'},
    ]
  const [weekDates, setWeekDates] = useState('')
  const [dateWeekInfo, setDateWeekInfo] = useState([])
  const [productTypes, setProductTypes] = useState([])
  const [perWeekLoading, setPerWeekLoading] = useState(false)
  const [productOptions, setProductOptions] = useState([])
  const stateOptions = [{id:'DUE', label:translate('ra.status.DUE')},{id:'DEFEATED', label:translate('ra.status.DEFEATED')}]
  const stateInvoiceOptions = [{id:'PENDING_BILLING', label:translate('ra.status.PENDING_BILLING')}, {id:'BILLED', label:translate('ra.status.BILLED')}]
  const SELECT_FIELDS = {'status':stateOptions,'currency':currencyOption, 'product_type':productTypes, 'product':productOptions, 'billing_status':stateInvoiceOptions/* ,'seller':sellerOPtions */}
  const [cantReserves, setCantReserves] = useState(0)
  const [cantCreditReserves, setCantCreditReserves] = useState(0)
  const [loadingReserves, setLoadingReserves] = useState(false)
  const [loadingCreditReserves, setLoadingCreditReserves] = useState(false)
  const [cardsShadow, setCardsShadow] = useState({expired:true, toExpire:false, available:false})
  const [isCardSelected, setIscardSelected] = useState(false)
  const [showExtraTitles, setShowExtraTitles] = useState(0)
  const [cardsSelection, setCardsSelection] = useState({expired:true, toExpire:false, available:false})
  const [reservesWithCredit, setReservesWithCredit] = useState([])
  const [amountPerPeriodData, setAmountPerPeriodData] = useState({})
  const [amountPerPeriodLoading, setAmountPerPeriodLoading] = useState(false)
  const [rankingData, setRankingData] = useState([])
  const [rankingLoading, setRankingLoading] = useState(false)
  const [forceRefreshKey, setForceRefreshKey] = useState(0);
  const [customBusinessUnit, setCustomBusinessUnit] = useState(null)
  const [workUnitTrigger, setWorkUnitTrigger] = useState(false)
  const [businessUnitTrigger, setBusinessUnitTrigger] = useState(false)
  const [amountPerPeriodTitles, setAmountPerPeriodTitles] = useState([])
  const [resetFilterValues, setResetFilterValues] = useState(false)
  const minToBackward = new Date()
  minToBackward.setDate((new Date()).getDate() + 1)
  const maxToForward = new Date()
  maxToForward.setDate((new Date()).getDate() + 20)
  const [displayedFilters, setDisplayedFilters] = useState({
      reservation_number: false,
      provider_code:false,
      pax_name:false,
      product_type:false,
      pax_surname:false,
      seller:false,
      currency:false,
      due_date:false,
      product:false,
      status:false,
      billing_status:false,
    })
  const [displayedCreditFilters, setDisplayedCreditFilters] = useState({
      reservation_number: false,
      provider_code:false,
      pax_name:false,
      product_type:false,
      pax_surname:false,
      seller:false,
      currency:false,
      due_date:false,
      product:false,
      status:false,
      billing_status:false
    })
  const [filter, setFilter] = useState({
      reservation_number: null,
      provider_code:null,
      product_type:null,
      pax_name:null,
      pax_surname:null,
      seller:null,
      currency:null,
      product:null,
      status:'DEFEATED',
      billing_status:null,
      due_date_from:null,
      due_date_to:null,
      sort:null
    })
  const [creditFilter, setCreditFilter] = useState({
      reservation_number: null,
      provider_code:null,
      product_type:null,
      pax_name:null,
      pax_surname:null,
      seller:null,
      currency:null,
      product:null,
      status:null,
      billing_status:null,
      due_date_from:null,
      due_date_to:null,
      sort:null
    })
  const form = useForm({
    defaultValues: {
      work_unit_id__in: null,
      business_unit_id__in:null,
      seller_id:null
    },
  });
  const [openSellerDialog, setOpenSellerDialog] = useState(false)
  const auxCreditsForm = useForm({})
  const auxForm = useForm({})
  const filters = [
    { source: 'number', name: translate('ra.field.number') },
    {source: 'provider_code', name: translate('ra.field.provider_code') },
    {source: 'pax_name', name: translate('ra.field.name') + ' ' + translate('ra.field.passenger') },
    {source: 'pax_surname', name: translate('ra.field.surname') + ' ' + translate('ra.field.passenger') },
    {source: 'seller', name: translate('ra.field.seller') },
    {source: 'currency', name: translate('ra.field.currency') },
    {source: 'due_date', name: translate('ra.field.due_date') },
    ...(hasPermissionFunction('account-state', 'filter')
        ?[{source: 'product', name: translate('ra.field.product') }]
        :[]),
    {source: 'status', name: translate('ra.field.status') },
    {source: 'product_type', name: translate('ra.field.product_type') },
    {source: 'billing_status', name: translate('ra.field.billing_status') },
  ]
  const creditFilters = [
    { source: 'number', name: translate('ra.field.number') },
    {source: 'pax_name', name: translate('ra.field.name') + ' ' + translate('ra.field.passenger') },
    {source: 'pax_surname', name: translate('ra.field.surname') + ' ' + translate('ra.field.passenger') },
    {source: 'seller', name: translate('ra.field.seller') },
    {source: 'currency', name: translate('ra.field.currency') },
  ]
  const onShowFilter = (filterName, value) => {
    setDisplayedFilters((displayedFilters) => ({
      ...displayedFilters,
      [filterName]: true,
    }))
  }

  const getDebtRanking = async () =>{
    setRankingLoading(true)
    await accountStateServices.getDebtRanking(form.getValues('work_unit_id__in')).then(res=>{
      setRankingData(res.result)
    })
    .finally(()=>{
      setRankingLoading(false)
    })
  }

  useEffect(()=>{
    if(hasPermissionFunction('account-state', 'filter')){
      getDebtRanking()
    }
  },[workUnitTrigger])

  const onClickCard = (status, status_name) =>{
    setIscardSelected(true)
    let newCardValues = {
      expired:false, 
      toExpire:false, 
      available:false
    }
    newCardValues[status] = !cardsSelection[status]
    if(cardsSelection[status]){
      setFilter({...filter, status:null})
    } else {
      setFilter({...filter, status:status_name})
    }
    setCardsSelection(newCardValues)

  }

  const getBalancesAmount = async () =>{
    setLoadingTotals(true)
    await accountStateServices.getBalancesAmount(form.getValues('business_unit_id__in')?? customBusinessUnit, form.getValues('work_unit_id__in'), sellerFilter).then((res)=>{
      setTotalsAmount(res)
    }).finally(()=>{
      setLoadingTotals(false)
    })
  }

  useEffect(()=>{
    if(weekDates.length > 0){
      setPerWeekLoading(true)
      accountStateServices.getBalancesPerWeek(weekDates, form.getValues('business_unit_id__in')?? customBusinessUnit, form.getValues('work_unit_id__in'), sellerFilter).then((res)=>{
        setDateWeekInfo(res?.result ?? [])
      }).finally(()=>{
        setPerWeekLoading(false)
      })
    }
  },[weekDates, businessUnitTrigger, workUnitTrigger, sellerFilter])

  const navigateToPayment = (reserve_id) =>{
    const url = new URL(window.location.href);
    const baseUrl = `${url.protocol}//${url.host}`;
    window.open(`${baseUrl}/#/reservation/${reserve_id}/show/`, '_blank');
  }

  useEffect(()=>{
    if(filter.sort || isCardSelected){
      onFilter()
    }
  },[filter.sort, filter.status])

  useEffect(()=>{
    if(creditFilter.sort || creditFilter.status){
      onCreditFilter()
    }
  },[creditFilter.sort, creditFilter.status])

  const onShowCreditFilter = (filterName, value) => {
    setDisplayedCreditFilters((displayedCreditFilters) => ({
      ...displayedCreditFilters,
      [filterName]: true,
    }))
  }

  const setUserSelected = (value) => {
    try {
      if (!value){
        setSellerFilter(null)
      }else {
        setSellerFilter(value)
      }
    } catch (error) {
      setSellerFilter(null)
    }
  }

  let searchTimeout
    const getUserB2 = async (user, length = 2) => {
      clearTimeout(searchTimeout)
  
      if (
        (!user?.firstname || user.firstname.length < length) &&
        (!user?.surname || user.surname.length < length)
      ) {
        setUserList([])
        return
      }
  
      searchTimeout = setTimeout(async () => {
        try {
          setLoadingUserList(true)
          let filter = {
            limit: 20
          }
          if (user?.firstname) {
            filter.firstname = user?.firstname
          }
          if (user?.surname) {
            filter.surname = user?.surname
          }
          const allUser = await reservationServices.userReservtionFilter(filter)
          setUserList(allUser)
        } catch (error) {
          setUserList([])
        } finally {
          setLoadingUserList(false)
        }
      }, 1000)
    }
  
  const [paginationItemData, setPaginationItemData] = useState({ page: 0, rowsPerPage: 10 })
  const [paginationCreditItemData, setPaginationCreditItemData] = useState({ page: 0, rowsPerPage: 10 })

  const ListContext = {
    displayedFilters: displayedFilters,
    filters:filter,
    hasCredit:null,
    work_unit_id:form.getValues('work_unit_id__in'),
    business_unit_id:customBusinessUnit ?? form.getValues('business_unit_id__in'),
    seller_filter:form.getValues('seller_id'),
    showFilter:onShowFilter,
    setFilters:setDisplayedFilters,
  };

  const ListCreditContext = {
    displayedFilters: displayedCreditFilters,
    filters:creditFilter,
    hasCredit:true,
    work_unit_id:form.getValues('work_unit_id__in'),
    business_unit_id:customBusinessUnit ?? form.getValues('business_unit_id__in'),
    seller_filter:form.getValues('seller_id'),
    showFilter:onShowCreditFilter,
    setFilters:setDisplayedCreditFilters,
  };
  const ListContextSelects = {
    filterValues: {
      work_unit_id__in: '',
      business_unit_id__in:''
    }
  }
  const [daysToDisplay, setDaysToDisplay] = useState([])
  const weeklyExpiredReserve = [
    'reservation_number',
    ...(hasPermissionFunction('account-state', 'show_tma') 
      ? ['tma_business'] 
      : []),
    'business_unit',
    'seller', 'passenger','currency', 
    'total','charged', 'overdue_balance', 'balance_due'
  ]
  const weeklyExpiredReserveWithCredits = [
    'reservation_number',
    ...(hasPermissionFunction('account-state', 'show_tma') 
      ? ['tma_business'] 
      : []),
    'business_unit',
    'seller', 'passenger', 'currency', 'credit_balance'
    /* 'total','charged',  */
  ]
  const onPageItemChange = (number) => {
    const paginationItemDataAux = { ...paginationItemData }
    paginationItemDataAux.page = number
    setShowExtraTitles(0)
    setPaginationItemData(paginationItemDataAux)
  }

  const onPageCreditItemChange = (number) => {
    const paginationItemDataAux = { ...paginationCreditItemData }
    paginationItemDataAux.page = number
    setPaginationCreditItemData(paginationItemDataAux)
  }

  const onFilter = () =>{
    if(paginationItemData.page === 0 && paginationItemData.rowsPerPage === 10){
      getReservations()
    }
    setPaginationItemData({ page: 0, rowsPerPage: 10 })
    setShowExtraTitles(0)
  }

  useEffect(()=>{
    form.setValue('work_unit_id__in',null);
  },[forceRefreshKey])

  const onCreditFilter = () =>{
    if(paginationCreditItemData.page === 0 && paginationCreditItemData.rowsPerPage === 10){
      getReservationsWithCredits()
    }
    setPaginationCreditItemData({ page: 0, rowsPerPage: 10 })
  }

  const getReservations = async () =>{
    setLoadingReserves(true)
    await accountStateServices.getReservations(paginationItemData.page, paginationItemData.rowsPerPage, filter, form.getValues('business_unit_id__in') ?? customBusinessUnit, form.getValues('work_unit_id__in'), sellerFilter).then(res=>{
      setReserves(res.reserves)
      setCantReserves(res.count)
    })
    .finally(()=>{
      setLoadingReserves(false)
    })
  }

  const getReservationsWithCredits = async () =>{
    setLoadingCreditReserves(true)
    await accountStateServices.getReservationsWithCredits(paginationCreditItemData.page, paginationCreditItemData.rowsPerPage, creditFilter, form.getValues('business_unit_id__in')?? customBusinessUnit, form.getValues('work_unit_id__in'), sellerFilter).then(res=>{
      setReservesWithCredit(res.reserves)
      setCantCreditReserves(res.count)
    })
    .finally(()=>{
      setLoadingCreditReserves(false)
    })
  }

  const displayContent = () =>{
    if(hasPermissionFunction('account-state', 'filter')){
      if((!form.getValues('business_unit_id__in') && !form.getValues('seller_id') && !form.getValues('work_unit_id__in') &&
      !customBusinessUnit
    )){
        return false
      }
    }
    return true
  }

  const onRowsPerPageItemChange = (e) => {
    const paginationItemDataAux = { ...paginationItemData }
    paginationItemDataAux.rowsPerPage = parseInt(e.target.value, 10)
    paginationItemDataAux.page = 0
    setPaginationItemData(paginationItemDataAux)
  }

  const onRowsPerPageCreditItemChange = (e) => {
    const paginationItemDataAux = { ...paginationCreditItemData }
    paginationItemDataAux.rowsPerPage = parseInt(e.target.value, 10)
    paginationItemDataAux.page = 0
    setPaginationCreditItemData(paginationItemDataAux)
  }

  /* const getCurrencyOptions = async () =>{
    setCurrencyOptions([
      {id:'USD', label:'USD'},
      {id:'ARS', label:'ARS'},
    ])
    await currencyServices.getByAll().then((res)=>{
      setCurrencyOptions(res.map(cur=>{return {id:cur.short_name, label:cur.short_name}}))
    })
  } */

  const getProductTypes = async () =>{
    await productServices.getAllProductTypes().then((res)=>{
      setProductTypes(res.map(type=>{return {id:type.id, label:type.long_name}}))
    })
  }

  const getProducts = async () =>{
    await productServices.getByAll().then(res=>{
      setProductOptions(res.map(prod=>{return {id:prod.id, label:prod.long_name}}))
    })
  }

  useEffect(()=>{
    /* if(displayedFilters.currency){
      getCurrencyOptions()
    } */
    if(displayedFilters.product_type){
      getProductTypes()
    }
    if(displayedFilters.product){
      getProducts()
    }
  },[displayedFilters])

  const getAmountPerPeriod = async () =>{
    setAmountPerPeriodLoading(true)
    await accountStateServices.getAmountPerPeriod(form.getValues('business_unit_id__in')?? customBusinessUnit, form.getValues('work_unit_id__in'), sellerFilter).then(res=>{
     let refactor_amounts = {}
     let titlesAux = []
     const totals = res.total
     for (const [key, value] of Object.entries(res.amounts)) {
      const value_currencies = Object.values(value)[0]
      for(let curr of value_currencies){
        let currency_amount = 0
        if(curr){
          currency_amount = curr.totalAmount
        }
        if(refactor_amounts[curr._id]){
          refactor_amounts[curr._id][key] = currency_amount
        } else {
          refactor_amounts[curr._id] = {[key]:currency_amount}
        }
        refactor_amounts[curr._id]['total'] = totals[curr._id]
        if(totals[curr._id]){

        }
        
      }
      titlesAux.push(Object.keys(value)[0]) 
      /* const ars_currency = value_currencies.find(cur=>cur._id === 'ARS')
      const usd_currency = value_currencies.find(cur=>cur._id === 'USD')
      const mxn_currency = value_currencies.find(cur=>cur._id === 'MXN')
      let currency_amount_ars = 0
      let currency_amount_usd = 0
      let currency_amount_mxn = 0
      if(ars_currency){
        currency_amount_ars = ars_currency.totalAmount
      }
      if(refactor_amounts['ARS']){
        refactor_amounts['ARS'][key] = currency_amount_ars
      } else {
        refactor_amounts['ARS'] = {[key]:currency_amount_ars}
      }
      if(usd_currency){
        currency_amount_usd = usd_currency.totalAmount
      }
      if(refactor_amounts['USD']){
        refactor_amounts['USD'][key] = currency_amount_usd
      } else {
        refactor_amounts['USD'] = {[key]:currency_amount_usd}
      }
      if(mxn_currency){
        currency_amount_mxn = mxn_currency.totalAmount
      }
      if(refactor_amounts['MXN']){
        refactor_amounts['MXN'][key] = currency_amount_mxn
      } else {
        refactor_amounts['MXN'] = {[key]:currency_amount_mxn}
      }
      refactor_amounts['ARS']['total'] = totals['ARS']
      refactor_amounts['USD']['total'] = totals['USD']
      refactor_amounts['MXN']['total'] = totals['MXN']

      titlesAux.push(Object.keys(value)[0]) */
     }
     setAmountPerPeriodTitles(titlesAux)
     for (const [key, value] of Object.entries(res.amounts)) {
      if(!(Object.values(value)[0] && Object.values(value)[0].length > 0)){
        for(const [amounts_key,_] of Object.entries(refactor_amounts)){
          refactor_amounts[amounts_key][key] = 0
        }
      }
     }
    setAmountPerPeriodData(refactor_amounts)
    }).finally(()=>{
      setAmountPerPeriodLoading(false)
    })
  }

  useEffect(()=>{
    /* getLatestpayments() */
    setFilter({status:'DEFEATED'})
    setCreditFilter({})
    setDisplayedFilters({})
    setDisplayedCreditFilters({})
    setCardsSelection({expired:true, toExpire:false, available:false})
    setCardsShadow({expired:true, toExpire:false, available:false})
    getBalancesAmount()
    getAmountPerPeriod()
    if(form.getValues('business_unit_id__in') || form.getValues('work_unit_id__in') || form.getValues('seller_id')){
      setCustomBusinessUnit(null)
    }
  },[businessUnitTrigger, workUnitTrigger, form.watch('seller_id')])

  useEffect(()=>{
    getReservations()
  },[paginationItemData, updateReserves, businessUnitTrigger, workUnitTrigger, sellerFilter])

  useEffect(()=>{
    getReservationsWithCredits()
  },[paginationCreditItemData, updateCreditReserves, businessUnitTrigger, workUnitTrigger, sellerFilter])

  useEffect(()=>{
    getFullDateInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dayToDisplay])

  const getSpanishDateInfo = (date) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const formatter = new Intl.DateTimeFormat('es-ES', options);
    const parts = formatter.formatToParts(date);

    const getPart = (type) => parts.find(p => p.type === type)?.value;

    return {
      dayOfWeek: getPart('weekday').substring(0, 3),
      dayOfMonth: getPart('day'),
      date:date?.toISOString()?.split('T')[0]
    };
  }

  const getFullDateInfo = () => {

    let auxDays = []

    const datePivot = dayToDisplay.getDay()
    let weekDatesStr = ''
    for(let i = datePivot; i >= 0; i--){
      const nextDate = new Date(dayToDisplay);
      nextDate.setDate(dayToDisplay.getDate() - i);
      auxDays.push(getSpanishDateInfo(nextDate));
      weekDatesStr = weekDatesStr + nextDate.toISOString().split('T')[0] + ','
    }

    for(let i = 1; i < 7 - datePivot; i++){
      const nextDate = new Date(dayToDisplay);
      nextDate.setDate(dayToDisplay.getDate() + i);
      auxDays.push(getSpanishDateInfo(nextDate));
      weekDatesStr = weekDatesStr + nextDate.toISOString().split('T')[0] + ','
    }
    weekDatesStr = weekDatesStr.slice(0, -1);
    setWeekDates(weekDatesStr)
    setDaysToDisplay(auxDays)
    
  }

  const changeMonth = (new_date) =>{
    let currentParts = monthFormatter.formatToParts(new_date)
    while(currentParts.find(part=>part.type === 'weekday').value != 'dom'){
      currentParts = monthFormatter.formatToParts(new_date.setDate(new_date.getDate() - 1))
    }
    setCurrentMonth(currentParts.find(part=>part.type === 'month').value)
  }

  const forwardWeeklyCalendar = () =>{
    if(dayToDisplay < maxToForward){
      const today = new Date(dayToDisplay);
      const futureDate = new Date(dayToDisplay);
      futureDate.setDate(today.getDate() + 7);
      setWeekIndex(weekIndex + 1)
      setDayToDisplay(futureDate)
      changeMonth(futureDate)
    }
    
  }

  const goWeeklyCalendar = (index) =>{
    setWeekIndex(index)
    const today = new Date();
    today.setDate((new Date()).getDate() + (index * 7));
    setDayToDisplay(today)
    changeMonth(today)
  }

  const backwarWeeklyCalendar = () =>{

    if(dayToDisplay > minToBackward ){
      const today = new Date(dayToDisplay);
      const futureDate = new Date(dayToDisplay);
      futureDate.setDate(today.getDate() - 7);
      setWeekIndex(weekIndex - 1)
      setDayToDisplay(futureDate)
      changeMonth(futureDate)
    }
    
  }

  const mapSortColumns = (column) =>{
    if(column === 'overdue_balance'){
      return 'total_pending_overdue'
    }
    if(column === 'balance_due'){
      return 'total_pending_due'
    }
    if(column === 'charged'){
      return 'total_paid'
    }
    if(column === 'credit_balance'){
      return 'credits'
    }
    if(column === 'business_unit'){
      return 'business_unit_name'
    }
    if(column === 'total'){
      return 'total_total'
    } 
    if(column === 'seller'){
      return 'user'
    }
    if(column === 'reservation_number'){
      return 'number'
    }
    if(column === 'passenger'){
      return 'items.pax_relation.name//items.pax_relation.surname'
    }
    return column
  }

  const checkIfAmountPeriodHasInfo = (periods) =>{
    for(const period in periods){
      const value = periods[period]
      for(const key in value){
        if(value[key] > 0){
          return true
        }
      }
    }
    return false
  }

  useEffect(()=>{
    for(let item of Object.keys(displayedFilters)){
      if(!displayedFilters[item] && ((filter[item] && item !== 'status') || (item === 'due_date' && (filter['due_date_to'] || filter['due_date_from'])))){
        if(item === 'due_date'){
          setFilter({...filter, due_date_from:null, due_date_to:null})
        } else {
          setFilter({...filter, [item]:null})
        }
        setPaginationItemData({ page: 0, rowsPerPage: 10 })
        setUpdateReserves(!updateReserves)
      }
    }
  },[displayedFilters])

  useEffect(()=>{
    for(let item of Object.keys(displayedCreditFilters)){
      if(!displayedCreditFilters[item] && (creditFilter[item] || (item === 'due_date' && (creditFilter['due_date_to'] || creditFilter['due_date_from'])))){
        if(item === 'due_date'){
          setCreditFilter({...creditFilter, due_date_from:null, due_date_to:null})
        } else {
          setCreditFilter({...creditFilter, [item]:null})
        }
        setPaginationCreditItemData({ page: 0, rowsPerPage: 10 })
        setUpdateCreditReserves(!updateCreditReserves)
      }
    }
  },[displayedCreditFilters])

  const updateFilters = (key) =>{
    let auxFilters = {...displayedFilters}
    auxFilters[key] = false
    /* setUpdateReserves(!updateReserves) */
    setDisplayedFilters(auxFilters)
  }

  const updateCreditFilters = (key) =>{
    let auxFilters = {...displayedCreditFilters}
    auxFilters[key] = false
    /* setUpdateCreditReserves(!updateCreditReserves) */
    setDisplayedCreditFilters(auxFilters)
  }

  return (
    <div>
      <FormProvider {...form}>
        <Dialog open={openSellerDialog} maxWidth='md' fullWidth onClose={()=>setOpenSellerDialog(false)}>
          <DialogTitle display='flex' justifyContent='space-between'>
            {translate('ra.field.seller')}
            <IconButton size='small' onClick={()=>setOpenSellerDialog(false)}>
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <MultiAutocompleteInput
              source='seller_id'
              options={usersList}
              loading={usersLoading}
              optionsText={['firstname', 'surname']}
              optionValue='id'
              onSearch={getUserB2}
              resetOnLoad={false}
              fields={['firstname', 'surname']}
              onChange={(e) => setUserSelected(e?.target?.value?.id_reservation_user)}
              disablePortal={false}
            />
          </DialogContent>
        </Dialog>
        <ListContextProvider value={ListContextSelects}>
          {hasPermissionFunction('account-state', 'filter') &&
          <>
          <div style={{display:'flex', flexDirection:'row'}}>
            <div style={{width:'50%'}}>
              <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between', width:'100%', margin:'15px'}}>
                <div style={{width:'100%', paddingBottom:'15px', display:'flex', flexDirection:'row', alignItems:'center'}}>
                  <Tooltip title={translate('ra.field.work_unit')}>
                    <BusinessCenterIcon/>
                  </Tooltip>
                  <TreeViewInput
                      key={forceRefreshKey}
                      loadingLabel={translate('ra.action.loadingWorkUnit')}
                      setCustomtrigger = {setWorkUnitTrigger}
                      customTrigger={workUnitTrigger}
                      queryOptions={
                        {
                          staleTime: Infinity, 
                          refetchOnWindowFocus: false,
                        }
                      }
                      queryName='work-unit-all'
                      fieldName='work_unit_id__in'
                      modalTitle={translate('ra.title.select_work_unit')}
                      buttonText={translate('ra.message.filter_by_work_unit')}
                      labelField={['label']}
                      setResetFilterValues ={setResetFilterValues}
                      resetValues = {resetFilterValues}
                      queryFn={workUnitServices.getByOrderParent}
                    />
                </div>
                <div style={{width:'100%', display:'flex', flexDirection:'row', alignItems:'center'}}>
                  <Tooltip title={translate('ra.field.business_unit')}>
                    <BusinessIcon/>
                  </Tooltip>
                  <TreeViewInput
                    loadingLabel={translate('ra.action.loadingBusinessUnit')}
                    queryName='business-unit-all'
                    key={forceRefreshKey}
                    setCustomtrigger = {setBusinessUnitTrigger}
                    customTrigger={businessUnitTrigger}
                    fieldName='business_unit_id__in'
                    queryOptions={
                        {
                          staleTime: Infinity, 
                          refetchOnWindowFocus: false,
                        }
                      }
                    setResetFilterValues ={setResetFilterValues}
                    resetValues = {resetFilterValues}
                    modalTitle='Selecciona una unidad de negocio'
                    buttonText={translate('ra.message.filter_by_business_unit')}
                    altLabel={['label']}
                    labelField={['fiscal_data_relation.name', 'fantasy_name']}
                    queryFn={businessUnitServices.getByOrderParent}
                  />
                </div>
              </div>
              <div style={{width:'100%', margin:'15px', display:'flex', flexDirection:'row', alignItems:'center'}}>
                <Tooltip title={translate('ra.field.seller')}>
                  <PersonIcon/>
                </Tooltip>
                <Box width={'100%'}>
                  <ButtonMat
                    sx={{
                      border: 'none',
                      width: '100%',
                      height: '40px',
                    }}
                    onClick={()=>setOpenSellerDialog(true)}
                    variant='outlined'
                    style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}
                  >
                    <span style={{ textWrap: 'nowrap', textOverflow: 'ellipsis', overflowX: 'hidden' }}>
                      {
                        form.getValues('seller_id') ? 
                        form.getValues('seller_id').firstname + ' ' + form.getValues('seller_id').surname
                        :
                        translate('ra.message.filter_by_seller')
                      }
                    </span>
                    {form.getValues('seller_id') && <EditIcon/>}
                  </ButtonMat>
                </Box>
              </div>
            </div>
            <div style={{display:'flex', alignSelf:'flex-start', marginLeft:'10%', marginTop:'15px'}}>
              {(customBusinessUnit || form.getValues('business_unit_id__in') || form.getValues('seller_id') || form.getValues('work_unit_id__in'))
              &&
              <Button variant='contained'size='small' style={{width:'100px'}} onClick={()=>{
                  form.reset(); 
                  setResetFilterValues(true);
                  setCustomBusinessUnit(null)
                }}>
                {translate('ra.action.clear')}
              </Button>}
            </div>
          </div>
        </>
           }
          </ListContextProvider>
        </FormProvider>
      {displayContent() && <div>
      <HeaderInfo/>
      <div style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-evenly'}}>
        <CardCommon title={translate('ra.title.balances')} headerStyle={AccountStateStyles.cardHeaderCommoncard} style={{borderRadius:'10px', marginTop:'15px', boxShadow: '0px 4px 10px rgba(0,0,0,0.2)', width:'40%'}}> 
          {/* <Chip label="moneda principal - moneda secundaria" style={{backgroundColor:'rgb(103, 196, 145)'}}/> */}
          <div style={{display:'flex', flexDirection:'row', marginTop:'15px', justifyContent:'space-between'}}>
            <CardCommon
              onMouseEnter = {
                ()=>{
                  setCardsShadow({toExpire:false, available:false, expired:true})
                }
              }
              onMouseLeave = {
                ()=>{
                  setCardsShadow({...cardsShadow, expired:false})
                }
              }
              headerStyle={{
                ...AccountStateStyles.cardHeader,
                borderBottomColor:expiredColor,
                cursor:'pointer',
                backgroundColor:cardsSelection.expired ? expiredColor:''
              }}
              onClick={()=>{
                if(!loadingTotals)
                  onClickCard('expired', 'DEFEATED')
                
              }}
              customTitle={
                <div style={{display:'flex', alignItems:'center', color:cardsSelection.expired?'rgb(255, 255, 255)':''}}>
                  <InfoOutlinedIcon color={cardsSelection.expired?'rgb(255, 255, 255)':'error'}/>
                  {'Saldo total vencido'}
                  <Tooltip title={translate('ra.message.due_tooltip')}>
                    <IconButton>
                      <InfoIcon fontSize='small' color={cardsSelection.expired?'rgb(255, 255, 255)':'info'}/>
                    </IconButton>
                  </Tooltip>
                </div>
              } 
              style={{...AccountStateStyles.cardBody, 
                borderColor:expiredColor,
                cursor:'pointer',
                width:'33%',
                boxShadow: cardsSelection.expired || cardsShadow.expired ?'0 4px 8px rgba(0, 0, 0, 0.2)':'',
              }}>
                <div style={{display:'flex', flexDirection:'column'}}>
                {loadingTotals ? 
                  <Skeleton/>
                :
                    <div>
                      {
                        totalsAmount.total_expired?.sort((a, b) =>a._id?.localeCompare(b._id)).map(total=>(
                          total._id && <div style={{color:expiredColor, display:'flex', flexDirection:'row'}}>
                            {total._id + ' '}
                            {
                              numberFormatterWithDecimalAndThousand(total.totalAmount)
                            }
                          </div>
                        ))
                      }
                      {/* <div style={{color:expiredColor, display:'flex', flexDirection:'row'}}>
                        {'ARS' + ' '}
                        {
                          totalsAmount.total_expired?.find(amount=>amount._id === 'ARS') &&
                          totalsAmount.total_expired?.find(amount=>amount._id === 'ARS').totalAmount ?
                          numberFormatterWithDecimalAndThousand(totalsAmount.total_expired?.find(amount=>amount._id === 'ARS').totalAmount) :
                          0
                        }
                      </div>
                      <div style={{color:expiredColor, display:'flex', flexDirection:'row'}}>
                        {'USD' + ' '}
                        {
                          totalsAmount.total_expired?.find(amount=>amount._id === 'USD') && 
                          totalsAmount.total_expired?.find(amount=>amount._id === 'USD').totalAmount ?
                          numberFormatterWithDecimalAndThousand(totalsAmount.total_expired?.find(amount=>amount._id === 'USD').totalAmount) :
                          0
                        }
                      </div>
                      {totalsAmount.total_expired?.find(amount=>amount._id === 'MXN') && <div style={{color:expiredColor, display:'flex', flexDirection:'row'}}>
                        {'MXN' + ' '}
                        {
                          totalsAmount.total_expired?.find(amount=>amount._id === 'MXN').totalAmount ?
                          numberFormatterWithDecimalAndThousand(totalsAmount.total_expired?.find(amount=>amount._id === 'MXN').totalAmount) :
                          0
                        }
                      </div>} */}
                    </div>
                }
                </div>
            </CardCommon>
            <CardCommon
              onMouseEnter = {
                ()=>{
                  setCardsShadow({expired:false, available:false, toExpire:true})
                }
              }
              onMouseLeave = {
                ()=>{
                  setCardsShadow({...cardsShadow, toExpire:false})
                }
              }
              headerStyle={{
                ...AccountStateStyles.cardHeader,
                cursor:'pointer',
                backgroundColor:cardsSelection.toExpire ? 'gray':''
              }} 
              onClick={()=>{
                if(!loadingTotals)
                  onClickCard('toExpire', 'DUE')
                /* setCardsSelection({expired:false, toExpire:!cardsSelection.toExpire, available:false})
                setFilter({...filter, status:'DUE'}) */
              }}
              customTitle={
                <div style={{display:'flex', alignItems:'center',color:cardsSelection.toExpire?'rgb(255, 255, 255)':''}}>
                  <AccessTimeIcon color={cardsSelection.toExpire?'rgb(255, 255, 255)':''}/>
                  {'Saldo total a vencer'}
                  <Tooltip title={translate('ra.message.to_due_tooltip')}>
                    <IconButton>
                      <InfoIcon fontSize='small' color={cardsSelection.toExpire?'rgb(255, 255, 255)':'info'}/>
                    </IconButton>
                  </Tooltip>
                </div>
              } 
              style={{
                ...AccountStateStyles.cardBody,
                borderColor:'black',
                cursor:'pointer',
                width:'33%',
                boxShadow: cardsSelection.toExpire || cardsShadow.toExpire?'0 4px 8px rgba(0, 0, 0, 0.2)':'',
              }}>
                <div style={{display:'flex', flexDirection:'column'}}>
                {
                  loadingTotals ? 
                  <Skeleton/>
                :
                    <div>
                      {totalsAmount.total_due?.sort((a, b) =>a._id?.localeCompare(b._id)).map(total=>(
                        total._id && <div style={{color:toExpireColor, display:'flex', flexDirection:'row'}}>
                          {total._id + ' '}
                          {
                            numberFormatterWithDecimalAndThousand(total.totalAmount)
                          }
                        </div>
                      ))
                        
                      }
                      {/* <div style={{color:toExpireColor, display:'flex', flexDirection:'row'}}>
                        {'ARS' + ' '}
                        {
                          totalsAmount.total_due?.find(amount=>amount._id === 'ARS') &&
                          totalsAmount.total_due?.find(amount=>amount._id === 'ARS').totalAmount ?
                          numberFormatterWithDecimalAndThousand(totalsAmount.total_due?.find(amount=>amount._id === 'ARS').totalAmount) :
                          0
                        }
                      </div>
                      <div style={{color:toExpireColor, display:'flex', flexDirection:'row'}}>
                        {'USD' + ' '}
                        {
                          totalsAmount.total_due?.find(amount=>amount._id === 'USD') &&
                          totalsAmount.total_due?.find(amount=>amount._id === 'USD').totalAmount ?
                          numberFormatterWithDecimalAndThousand(totalsAmount.total_due?.find(amount=>amount._id === 'USD').totalAmount) :
                          0
                        }
                      </div>
                      {totalsAmount.total_due?.find(amount=>amount._id === 'MXN') && <div style={{color:toExpireColor, display:'flex', flexDirection:'row'}}>
                        {'MXN' + ' '}
                        {
                          totalsAmount.total_due?.find(amount=>amount._id === 'MXN').totalAmount ?
                          numberFormatterWithDecimalAndThousand(totalsAmount.total_due?.find(amount=>amount._id === 'MXN').totalAmount) :
                          0
                        }
                      </div>} */}
                    </div>
                  }
                </div>
            </CardCommon>
            <CardCommon
              onMouseEnter = {
                ()=>{
                  setCardsShadow({expired:false, toExpire:false, available:true})
                }
              }
              onMouseLeave = {
                ()=>{
                  setCardsShadow({...cardsShadow, available:false})
                }
              }
              headerStyle={{
                ...AccountStateStyles.cardHeader,
                borderColor:'rgb(103, 196, 145)',
                cursor:'pointer',
                backgroundColor:cardsSelection.available ? 'rgb(103, 196, 145)':''
              }}
              onClick={()=>{
                if(!loadingTotals){
                  onClickCard('available', null)
                  //setCardsSelection({expired:false, toExpire:false, available:!cardsSelection.available});
                  window.scrollTo({
                    top: document.body.scrollHeight,
                    behavior: 'smooth' // optional for smooth scroll
                  });
                }
              }}
              customTitle={
                <div style={{display:'flex', alignItems:'center', color:cardsSelection.available?'rgb(255, 255, 255)':''}}>
                  <CheckCircleOutlineIcon color={cardsSelection.available?'rgb(255, 255, 255)':'success'}/>
                  {translate('ra.field.credit_balance')}
                  <Tooltip title={translate('ra.message.credits_tooltip')}>
                    <IconButton>
                      <InfoIcon fontSize='small' color={cardsSelection.available?'rgb(255, 255, 255)':'info'}/>
                    </IconButton>
                  </Tooltip>
                </div>
              } 
              style={{
                ...AccountStateStyles.cardBody,
                borderColor:'rgb(103, 196, 145)',
                cursor:'pointer',
                width:'33%',
                boxShadow: cardsSelection.available || cardsShadow.available?'0 4px 8px rgba(0, 0, 0, 0.2)':'',
              }}
            >
              <div style={{display:'flex', flexDirection:'column'}}>
                {
                  loadingTotals ? 
                  <Skeleton/>
                :
                    <div>
                      {
                        totalsAmount.total_credits?.sort((a, b) =>a._id?.localeCompare(b._id)).map(total=>(
                          total._id && <div style={{color:'rgb(103, 196, 145)', display:'flex', flexDirection:'row'}}>
                            {total._id + ' '}
                            {
                              numberFormatterWithDecimalAndThousand(total.totalAmount)
                            }
                          </div>
                        ))
                      }
                      {/* <div style={{color:'rgb(103, 196, 145)', display:'flex', flexDirection:'row'}}>
                        {'ARS' + ' '}
                        {
                          totalsAmount.total_credits?.find(amount=>amount._id === 'ARS') &&
                          totalsAmount.total_credits?.find(amount=>amount._id === 'ARS').totalAmount ?
                          numberFormatterWithDecimalAndThousand(totalsAmount.total_credits?.find(amount=>amount._id === 'ARS').totalAmount) :
                          0
                        }
                      </div>
                      <div style={{color:'rgb(103, 196, 145)', display:'flex', flexDirection:'row'}}>
                        {'USD' + ' '}
                        {
                          totalsAmount.total_credits?.find(amount=>amount._id === 'USD') &&
                          totalsAmount.total_credits?.find(amount=>amount._id === 'USD').totalAmount ?
                          numberFormatterWithDecimalAndThousand(totalsAmount.total_credits?.find(amount=>amount._id === 'USD').totalAmount) :
                          0
                        }
                      </div>
                      {totalsAmount.total_credits?.find(amount=>amount._id === 'MXN') && <div style={{color:'rgb(103, 196, 145)', display:'flex', flexDirection:'row'}}>
                        {'MXN' + ' '}
                        {
                          totalsAmount.total_credits?.find(amount=>amount._id === 'MXN').totalAmount ?
                          numberFormatterWithDecimalAndThousand(totalsAmount.total_credits?.find(amount=>amount._id === 'MXN').totalAmount) :
                          0
                        }
                      </div>} */}
                    </div>
                  }
                </div>
            </CardCommon>
          </div>
        </CardCommon>
        <div style={{marginLeft:'15px', justifyContent:'space-between', display:'flex', flexDirection:'column', width:'50%'}}>
         {!hasPermissionFunction('account-state', 'filter') ? 
         <>
          <CardCommon title={translate('ra.title.how_much_to_pay')} headerStyle={AccountStateStyles.cardHeaderCommoncard} style={AccountStateStyles.cardStyle}>
            <div style={{display:'flex', flexDirection:'row', alignItems:'center', fontWeight:'bold'}}>
                {translate('ra.title.balance_to_pay')}
                <div style={{display:'flex', flexDirection:'row'}}>
                  {loadingTotals ?
                  <div style={{width:'100%'}}>
                    <Skeleton/>
                  </div>
                  :
                  totalsAmount.total_expired?.length > 0 ?
                    totalsAmount.total_expired?.map(total=>(
                      total._id &&
                      <div style={{color:expiredColor, display:'flex', flexDirection:'row'}}>
                        <Chip label={total._id + ' ' + numberFormatterWithDecimalAndThousand(total.totalAmount)} style={{backgroundColor:expiredColor, margin:'5px'}}/>
                      </div>
                    )) :
                    <Chip label={translate('ra.message.up_to_date')} style={{backgroundColor:'rgb(103, 196, 145)', margin:'5px'}}/>
                  }
                </div>
            </div>
          </CardCommon>
          <CardCommon title={`${translate('ra.title.weekly_due_dates')} - ${currentMonth}`} style={AccountStateStyles.cardStyle} headerStyle={AccountStateStyles.cardHeaderCommoncard}>
            <TableContainer>
              <Table sx={{...AccountStateStyles.tableStyle, tableLayout: 'fixed', width: '100%'}}>
                <TableHead>
                  <TableRow>
                    {
                      daysToDisplay.map(item=>(
                        <TableCell style={Number(item.dayOfMonth) === (new Date()).getDate() ? {backgroundColor:'#6f7ce0', color:'white'}:{}} key={item.dayOfMonth}>
                          <div  style={{alignItems:'center', display:'flex', flexDirection:'row', justifyContent:'center', fontWeight:'bold'}}>
                            {item.dayOfWeek}
                          </div> 
                        </TableCell>
                      ))
                    }
                  </TableRow>
                  <TableRow>
                    {
                      daysToDisplay.map(day=>(
                        <TableCell sx={{ verticalAlign: 'top', padding:'5px' }}  key={day.dayOfMonth}>
                            <div style={{display:'flex', color:'rgb(47, 172, 235)'}}>{day.dayOfMonth}</div>
                
                            <div style={{display:'flex', flexDirection:'column', fontSize:'10px', minHeight:'40px'}}>
                              {
                                perWeekLoading ? 
                                <Skeleton/>
                              :
                              dateWeekInfo?.filter(date=>Object.keys(date)[0] === day.date).length > 0 && 
                                dateWeekInfo?.filter(date=>Object.keys(date)[0] === day.date)[0][day.date]?.map(info=>(
                                  info._id &&
                                  <div style={{color:new Date(day.date) > today ? toExpireColor : expiredColor, display:'flex', flexDirection:'row',fontSize:'14px'}}>
                                    {info._id + ' '}
                                    {numberFormatterWithDecimalAndThousand(info.totalAmount)}
                                  </div>
                                ))
                              }
                          </div>
                        </TableCell>
                      ))
                    }
                  </TableRow>
                </TableHead>
              </Table>
          </TableContainer>
            <div style={{display:'flex', flexDirection:'row', marginTop:'15px', justifyContent:'flex-end'}}>
                <KeyboardArrowLeftIcon 
                  style={{cursor:dayToDisplay > minToBackward ?'pointer':'default', color:dayToDisplay > minToBackward ?'black':'lightgray'}} 
                  onClick={backwarWeeklyCalendar}
                />
                  <div style={{display:'flex',width:'30%', flexDirection:'row', justifyContent:'space-evenly'}}>
                  {
                    Array.from({ length: 4 }, (_, i) =>i).map(i=>(
                      <label key={i} style={{cursor:'pointer', borderRadius:'100px', width:'25px', height:'25px', textAlign:'center' ,backgroundColor:weekIndex === i ? 'lightgray' : '', fontWeight:'bold'}} onClick={()=>{goWeeklyCalendar(i)}}>
                        {i + 1}
                      </label>
                    ))
                  }
                  </div>
                <KeyboardArrowRightIcon 
                  style={{cursor:dayToDisplay < maxToForward ?'pointer':'default', color:dayToDisplay < maxToForward ?'black':'lightgray'}} 
                  onClick={forwardWeeklyCalendar}
                />
            </div>
          </CardCommon> 
         </> 
          :
          <CardCommon title={'Ranking Deudores'} style={AccountStateStyles.cardStyle} headerStyle={AccountStateStyles.cardHeaderCommoncard}>
            <TableContainer>
              <Table sx={AccountStateStyles.tableStyle}>
                <TableHead>
                  <TableRow>
                  {
                    !rankingLoading ?
                      rankingData?.map(curency=>/* (curency[0]._id.currency == 'USD' || 
                        curency[0]._id.currency == 'ARS' ||
                       curency[0]._id.currency == 'MXN'
                      ) && */
                      curency[0]._id.currency && 
                      (
                        <TableCell>
                          {curency[0]._id.currency}
                        </TableCell>
                      )) :
                    <Skeleton/>
                  }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                  !rankingLoading ?
                    rankingData?.map(curency=>(
                      /* (curency[0]._id.currency == 'USD' || 
                        curency[0]._id.currency == 'ARS' ||
                        curency[0]._id.currency == 'MXN'
                      ) && */
                       curency[0]._id.currency &&
                      <TableCell>
                        {
                          curency.map((item, index)=>(
                            <TableRow style={{cursor:'pointer', backgroundColor:item._id.business_unit_id === customBusinessUnit && 'lightgray'}} 
                              onClick={()=>{
                                setCustomBusinessUnit(item._id.business_unit_id)
                                setBusinessUnitTrigger(!businessUnitTrigger)
                                setShowExtraTitles(0)
                                setForceRefreshKey(prev => prev + 1)
                                form.setValue('seller_id',null)
                                setSellerFilter(null)
                              }}>
                              <TableCell>
                                <div style={{backgroundColor:index + 1 > 2 ? 'rgba(240, 190, 155, 1)':expiredColor, borderRadius:'100%', width:'30px', height:'30px',textAlign:'center', padding:'5px'}}>
                                  {index + 1}
                                </div>
                              </TableCell>
                              <TableCell>
                            {item._id.business_unit}
                            </TableCell>
                          </TableRow>
                          ))
                        }
                      </TableCell>
                    )) :
                    <Skeleton/>
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </CardCommon>
        }
        </div>
      </div>
      
      <CardCommon title={translate('ra.title.detail_per_reservation')} style={AccountStateStyles.cardStyle} headerStyle={AccountStateStyles.cardHeaderCommoncard}>
        <CardCommon title={translate('ra.title.whith_balances')} style={AccountStateStyles.cardStyle} headerStyle={AccountStateStyles.cardHeaderCommoncard}>
        <ListContextProvider value={ListContext}>
          {reserves.length > 0 &&<ListViewTopToolbar
                customFilter
                exporterDisable
                FilterButtonComponent={AccountStateFilters}
                listFilters={filters}
                CustomExportButton={ExportButton}
              />}
          </ListContextProvider>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
            <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
              {Object.entries(displayedFilters).map(([key, value])=>(
                value &&
                <div key={key} style={{alignItems:'center', display:'flex', margin:'15px'}}>
                  <CancelIcon style={{cursor:'pointer'}} onClick={()=>{updateFilters(key)}}/>
                  {
                    Object.keys(SELECT_FIELDS).includes(key)?
                    
                    (
                    <Autocomplete
                      fullWidth
                      sx={{ width: 200 }}
                      size="small"
                      options={SELECT_FIELDS[key] || []}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) => option.id === value}
                      value={SELECT_FIELDS[key]?.find(item => item.id === filter[key]) || null}
                      onChange={(event, newValue) => {
                        setFilter({ ...filter, [key]: newValue?.id ?? null });
                      }}
                      renderInput={(params) => (
                        SELECT_FIELDS[key].length > 0 ?
                        <TextField
                          {...params}
                          label={translate(filters.find(item => item.source === key).name)}
                          variant="outlined"
                        />
                      :
                        <Skeleton style={{height:50}} />
                      )}
                    />)
                    : key === 'due_date' ? 
                    <div style={{display:'flex', justifyContent:'space-between', flexDirection:'row'}}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                      <DatePicker
                        value={filter.due_date_from || null}
                        maxDate={filter.due_date_to || null}
                        label={translate('ra.field.from')}
                        onChange={(date) => {
                            setFilter({...filter, [key + '_from']:date ?? null})
                          }}
                        renderInput={(params) => (
                          <TextField {...params} style={{width:'45%'}} fullWidth variant='outlined' size='small' error={false} />
                        )}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                      <DatePicker
                          value={filter.due_date_to || null}
                          label={translate('ra.field.to')}
                          minDate={filter.due_date_from || null}
                          onChange={(date) => {
                            let dateTime = date
                            if(date && date instanceof Date){
                              const dateFormatted = date.toISOString()
                              dateTime = `${dateFormatted.split('T')[0]}T23:59:59.000Z`
                            }
                            setFilter({...filter, [key + '_to']:dateTime ?? null})
                          }}
                          renderInput={(params) => (
                            <TextField {...params} style={{width:'45%'}} fullWidth variant='outlined' size='small' error={false} />
                          )}
                        />
                    </LocalizationProvider>
                    </div>:
                    key === 'seller' ?
                    <div>
                      <FormProvider {...auxForm}>
                      <MultiAutocompleteInput
                        source='choice'
                        options={usersList}
                        loading={usersLoading}
                        optionsText={['firstname', 'surname']}
                        optionValue='id'
                        onSearch={getUserB2}
                        resetOnLoad={false}
                        fields={['firstname', 'surname']}
                        onChange={(e) => setFilter({...filter, [key]:e?.target?.value?.id_reservation_user ?? null})}
                        disablePortal={false}
                      />
                      </FormProvider>
                    </div>
                    :
                    <TextField 
                      onChange={(value)=>{
                        setFilter({...filter, [key]:value.target.value ?? null})
                      }} 
                      label={translate(filters.find(item=>item.source === key).name)} 
                      size='small'
                    />
                  }
                </div>
              ))}
            </div>
            {Object.values(displayedFilters).some(item=>item) && 
              <LoadingButton 
                onClick={onFilter}
              >
                {translate('ra.action.filter')}
            </LoadingButton>}
          </div>
          {reserves.length > 0 || loadingReserves?
            <>
            <TableContainer>
              <Table sx={AccountStateStyles.tableStyle}>
                <TableHead>
                  <TableRow>
                    {
                      weeklyExpiredReserve.map(column=>{
                        const item = mapSortColumns(column)
                        return (
                        <TableCell key={column} onClick = {()=>{
                          if(filter.sort){
                            const sortItem = filter.sort.split('__')[0]
                            const sortOrder = filter.sort.split('__')[1]
                            if(sortItem === item){
                              if(sortOrder === '1'){
                                setFilter({...filter, sort:item + '__-1'})
                              } else if(sortOrder === '-1'){
                                setFilter({...filter, sort:''})
                              }
                            } else {
                              setFilter({...filter, sort:item + '__1'})
                            }
                          } else {
                            setFilter({...filter,sort:item + '__1'})
                          }
                        }}>
                          <div style={{alignItems:'center', display:'flex', flexDirection:'row', justifyContent:'center', fontWeight:'bold'}}>
                            {translate(`ra.field.${column}`)}
                            {filter.sort === item + '__1' &&
                              <ArrowUpwardIcon/>
                            }
                            {filter.sort === item + '__-1' &&
                              <ArrowDownwardIcon/>
                            }
                          </div>
                        </TableCell>
                      )})
                    }
                    {/* <TableCell>
                      {translate('ra.field.documents')}
                    </TableCell> */}
                    {
                      (showExtraTitles > 0) && ([ 
                        <TableCell >{translate('ra.field.product')}</TableCell>,
                        <TableCell >{translate('ra.field.due_date')}</TableCell>,
                        <TableCell >{translate('ra.field.status')}</TableCell>,
                        <TableCell >{translate('ra.field.billing_status')}</TableCell>,
                      ])
                    }
                  </TableRow>
                </TableHead>
                <TableBody>              
                  {loadingReserves ? 
                  <TableRow> 
                    {Array.from({ length: 9 }).map((i)=>(
                      <TableCell key={i}>
                        <Skeleton variant='rectangular' height={40} width={'100%'}/>
                      </TableCell>
                    ))}
                    </TableRow>      
                      :
                    reserves.map(reserve=>(
                      <ReservationRow reserve={reserve} setShowExtraTitles={setShowExtraTitles} showExtraTitles={showExtraTitles}/>
                    ))
                  }
                  
                </TableBody>
                <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        count={cantReserves}
                        rowsPerPage={paginationItemData.rowsPerPage}
                        page={paginationItemData.page}
                        onPageChange={(e, number) => onPageItemChange(number)}
                        onRowsPerPageChange={(e) => onRowsPerPageItemChange(e)}
                        labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                        labelDisplayedRows={({ from, to, count }) =>
                          `${from}–${to} ${translate('ra.navigation.of')} ${cantReserves}`
                        }
                      />
                    </TableRow>
                  </TableFooter>
              </Table>
            </TableContainer>
            </>
            :
            <div>
              {translate('ra.message.no_content_to_display')}
            </div>
          }
      </CardCommon>
      <CardCommon title={translate('ra.title.with_credits')} style={AccountStateStyles.cardStyle} headerStyle={AccountStateStyles.cardHeaderCommoncard}>
        <ListContextProvider value={ListCreditContext}>
          {reservesWithCredit.length > 0 && <ListViewTopToolbar
                customFilter
                exporterDisable
                FilterButtonComponent={AccountStateFilters}
                listFilters={creditFilters}
                CustomExportButton={ExportButton}
              />}
          </ListContextProvider>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
            <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap'}}>
              {Object.entries(displayedCreditFilters).map(([key, value])=>(
                value &&
                <div key={key} style={{alignItems:'center', display:'flex', margin:'15px'}}>
                  <CancelIcon style={{cursor:'pointer'}} onClick={()=>{updateCreditFilters(key)}}/>
                  {
                    Object.keys(SELECT_FIELDS).includes(key)?
                     (
                      <Autocomplete
                      fullWidth
                      sx={{ width: 200 }}
                      size="small"
                      options={SELECT_FIELDS[key] || []}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) => option.id === value}
                      value={SELECT_FIELDS[key]?.find(item => item.id === creditFilter[key]) || null}
                      onChange={(event, newValue) => {
                        setCreditFilter({ ...creditFilter, [key]: newValue?.id ?? null });
                      }}
                      renderInput={(params) => (
                        SELECT_FIELDS[key].length > 0 ?
                        <TextField
                          {...params}
                          label={creditFilters.find(item => item.source === key).name}
                          variant="outlined"
                        />
                      :
                        <Skeleton style={{height:50}} />
                      )}
                    />
                    )
                    : key === 'due_date' ? 
                    <div style={{display:'flex', justifyContent:'space-between', flexDirection:'row'}}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                      <DatePicker
                        value={creditFilter.due_date_from || null}
                        minDate={new Date()}
                        label={translate('ra.field.from')}
                        onChange={(date) => setCreditFilter({...creditFilter, [key + '_from']:date ?? null})}
                        renderInput={(params) => (
                          <TextField {...params} style={{width:'45%'}} fullWidth variant='outlined' size='small' error={false} />
                        )}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                      <DatePicker
                          value={creditFilter.due_date_to || null}
                          label={translate('ra.field.to')}
                          minDate={creditFilter.due_date_from || new Date()}
                          onChange={(date) => setCreditFilter({...creditFilter, [key + '_to']:date ?? null})}
                          renderInput={(params) => (
                            <TextField {...params} style={{width:'45%'}} fullWidth variant='outlined' size='small' error={false} />
                          )}
                        />
                    </LocalizationProvider>
                    </div>
                    : key === 'seller' ?
                    <div>
                      <FormProvider {...auxCreditsForm}>
                      <MultiAutocompleteInput
                        source='choice'
                        options={usersList}
                        loading={usersLoading}
                        optionsText={['firstname', 'surname']}
                        optionValue='id'
                        onSearch={getUserB2}
                        resetOnLoad={false}
                        fields={['firstname', 'surname']}
                        onChange={(e) => setCreditFilter({...creditFilter, [key]:e?.target?.value?.id_reservation_user ?? null})}
                        disablePortal={false}
                      />
                      </FormProvider>
                    </div>
                    :
                    <TextField 
                      onChange={(value)=>{
                        setCreditFilter({...creditFilter, [key]:value.target.value ?? null})
                      }} 
                      label={creditFilters.find(item=>item.source === key).name} 
                      size='small'
                    />
                  }
                </div>
              ))}
            </div>
            {Object.values(displayedCreditFilters).some(item=>item) && 
              <LoadingButton 
                onClick={onCreditFilter}
              >
                {translate('ra.action.filter')}
            </LoadingButton>}
          </div>
          {reservesWithCredit.length > 0 || loadingCreditReserves ?
          <>
            <TableContainer>
              <Table sx={AccountStateStyles.tableStyle}>
                <TableHead>
                  <TableRow>
                    {
                      weeklyExpiredReserveWithCredits.map(column=>{
                        const item = mapSortColumns(column);
                        return(
                        <TableCell key={column} onClick = {()=>{
                          if(creditFilter.sort){
                            const sortItem = creditFilter.sort.split('__')[0]
                            const sortOrder = creditFilter.sort.split('__')[1]
                            if(sortItem === item){
                              if(sortOrder === '1'){
                                setCreditFilter({...creditFilter, sort:item + '__-1'})
                              } else if(sortOrder === '-1'){
                                setCreditFilter({...creditFilter, sort:''})
                              }
                            } else {
                              setCreditFilter({...creditFilter, sort:item + '__1'})
                            }
                          } else {
                            setCreditFilter({...creditFilter,sort:item + '__1'})
                          }
                        }}>
                          <div style={{alignItems:'center', display:'flex', flexDirection:'row', justifyContent:'center', fontWeight:'bold'}}>
                            {translate(`ra.field.${column}`)}
                            {creditFilter.sort === item + '__1' &&
                              <ArrowUpwardIcon/>
                            }
                            {creditFilter.sort === item + '__-1' &&
                              <ArrowDownwardIcon/>
                            }
                          </div>
                        </TableCell>)
                      })
                    }
                  </TableRow>
                </TableHead>
                <TableBody>                    
                  {loadingCreditReserves ? 
                    Array.from({ length: 7 }).map((i)=>(
                      <TableCell key={i}>
                        <Skeleton variant='rectangular' height={40} width={'100%'}/>
                      </TableCell>
                    ))
                      :
                    reservesWithCredit?.map(reserve=>(
                      reserve?.items &&
                      <TableRow key={reserve._id} >
                        <TableCell style={{cursor:'pointer', color:'#6f7ce0'}} onClick={()=>navigateToPayment(reserve.id)}>
                          <div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                            {reserve.number}
                          </div>
                        </TableCell>
                        <HasPermission permission='show_tma' resource={'account-state'}>
                          <TableCell >
                            {reserve.sale_id}
                          </TableCell>
                        </HasPermission>
                        <TableCell >
                          {reserve.business_unit_name}
                        </TableCell>
                        <TableCell >
                          <div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                            {reserve.user}
                          </div>
                        </TableCell>
                        <TableCell >
                          {/* {reserve.items.length > 0 ? (reserve.items[0]?.pax_relation?.name + ' ' + reserve.items[0]?.pax_relation?.surname) : ''} */}
                          {reserve.passenger}
                        </TableCell>
                        <TableCell >
                          <div style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                            {reserve.currency_credits}
                          </div>
                        </TableCell>
                        {/* <TableCell >
                          <div style={{display:'flex', justifyContent:'flex-end'}}>
                            {numberFormatterWithDecimalAndThousand(reserve.total_total)}
                          </div>
                        </TableCell>
                        <TableCell >
                          <div style={{display:'flex', justifyContent:'flex-end'}}>
                            {numberFormatterWithDecimalAndThousand(reserve.total_paid)}
                          </div>
                        </TableCell> */}
                        <TableCell >
                          <div style={{display:'flex', justifyContent:'flex-end'}}>
                            {numberFormatterWithDecimalAndThousand(reserve.credits)}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  }
                  
                </TableBody>
                <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        count={cantCreditReserves}
                        rowsPerPage={paginationCreditItemData.rowsPerPage}
                        page={paginationCreditItemData.page}
                        onPageChange={(e, number) => onPageCreditItemChange(number)}
                        onRowsPerPageChange={(e) => onRowsPerPageCreditItemChange(e)}
                        labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                        labelDisplayedRows={({ from, to, count }) =>
                          `${from}–${to} ${translate('ra.navigation.of')} ${cantCreditReserves}`
                        }
                      />
                    </TableRow>
                  </TableFooter>
              </Table>
            </TableContainer>
            </>:
            <div>
              {translate('ra.message.no_content_to_display')}
            </div>
          }
          </CardCommon>
      </CardCommon>
      <CardCommon title={translate('ra.title.debt_per_period')} style={AccountStateStyles.cardStyle} headerStyle={AccountStateStyles.cardHeaderCommoncard}>
        {checkIfAmountPeriodHasInfo(amountPerPeriodData) || amountPerPeriodLoading ?
        <TableContainer>
              <Table sx={AccountStateStyles.tableStyle}>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <div  style={{alignItems:'center', display:'flex', flexDirection:'row', justifyContent:'center', fontWeight:'bold'}}>
                        {'Mon/Días de mora'}
                      </div>
                    </TableCell>
                    {
                      amountPerPeriodTitles.map((item, index)=>(
                          <TableCell key={index}>
                            <div  style={{alignItems:'center', display:'flex', flexDirection:'row', justifyContent:'center', fontWeight:'bold'}}>
                              {item}
                            </div>
                          </TableCell>
                      ))
                    }
                    <TableCell>
                      <div  style={{alignItems:'center', display:'flex', flexDirection:'row', justifyContent:'center', fontWeight:'bold'}}>
                        {'Total'}
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>
  
                <TableBody>
                  {
                    amountPerPeriodLoading ?
                    Array.from({ length:11 }).map((i)=>(
                      <TableCell key={i}>
                        <Skeleton variant='rectangular' height={40} width={'100%'}/>
                      </TableCell>
                    ))
                      :
                    Object.entries(amountPerPeriodData).sort().map(([key, value]) => (
                      <TableRow>
                        <TableCell key={key}>{key}</TableCell>
                        {
                        Object.entries(value).map(([key, value]) => (
                          <TableCell sx={{
                            color:key < 5 ? 'rgb(212, 14, 0)' : (key == 5 ? '#e66700' : ((key > 5 && key < 9) ? 'rgb(2, 212, 97)' :'black'))
                          }} key={key}>{numberFormatterWithDecimalAndThousand(value)}</TableCell>
                        ))
                        }
                      </TableRow>
                    ))
                  }
                </TableBody>
              </Table>
          </TableContainer>:
          <div>
            {translate('ra.message.no_content_to_display')}
          </div>
          }
      </CardCommon>
      </div>}
    </div>
  )
}

const AccountStateStyles = {

  tableStyle:{
    borderCollapse: 'separate',
    borderSpacing: 0,
    '& .RaDatagrid-headerCell:first-of-type': {
      borderTopLeftRadius: '12px',
    },
    '& .RaDatagrid-headerCell:last-of-type': {
      borderTopRightRadius: '12px',
    },
    '& .RaDatagrid-row:last-of-type > .MuiTableCell-root:first-of-type': {
      borderBottomLeftRadius: '12px',
    },
    '& .RaDatagrid-row:last-of-type > .MuiTableCell-root:last-of-type': {
      borderBottomRightRadius: '12px',
    },
      '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .RaDatagrid-row': {
      borderBottom: 'none',
    },
  },

  cardStyle:{
    width:'100%', 
    marginTop:'15px',
    borderRadius:'10px',
    boxShadow: '0px 4px 10px rgba(0,0,0,0.2)'
  },

  cardBody:{
    borderWidth:'1px', 
    borderStyle:'solid',
    borderRadius:'10px',
    margin:'5px'
  },

  cardHeader:{
    borderBottomWidth:'1px', 
    borderBottomStyle:'solid', 
    fontSize:'10px',
  },

  cardHeaderCommoncard:{
    fontWeight:'bolder',
    backgroundColor:'rgb(228, 239, 247)'
  }
}